
import { Component, Vue } from "vue-property-decorator";
import { Login } from "@/models/login";
import { API_STORE } from "@/config";
import { setUserViewPermissions } from "@/services/auth";
import NewPageLoader from "@/views/NewPageLoader.vue";
import Axios from "axios";
import $ from "jquery";
import { isSubdomain, getDomainName } from "@/services/common";
const Avatar = () => import("vue-avatar");
import Swal from "sweetalert2";

@Component({ components: { Avatar, NewPageLoader } })
export default class LoginComponent extends Vue {
  public credentials = new Login();
  public showPassword = false;
  public imageName = "Instant Payment";
  public showLogo = false;
  public OTPVerificationMsg = null;
  public inputOTP = null;
  public submitSave = false;
  public resendOtpDisabled = true;
  public newPageLoader = true;
  public latitude = null;
  public longitude = null;
  public loginSlider1 = null;
  public loginSlider2 = null;
  public loginSlider3 = null;

  public async validateAndLogin() {
    this.initGeolocation();
    let result = await this.$validator.validateAll();
    if (!result) {
      this.submitSave = true;
      return;
    }
    if (!this.latitude && !this.longitude) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please Enable Location!",
        showConfirmButton: true,
      });
      return;
    }
    if (this.inputOTP != "" && this.inputOTP) this.verifyOTP();
    else {
      this.newPageLoader = true;
      /**
       * Post to server
       */
      let response = await Axios.post(API_STORE.AUTHENTICATION + "login", {
        ...this.credentials,
        customDomainCall: isSubdomain() ? true : false,
        subdomain: isSubdomain() ? getDomainName() : null,
        sessionTiming: JSON.parse(
          localStorage.getItem(this.credentials.userName)),
         link: 'https://www.google.com/maps/@27.4792448,77.676544,14z'
      });
      this.newPageLoader = false;
      /**
       * handle otp verification
       */
      if (response && response.data) {
        if (response.data.hasOwnProperty("otpSent") && response.data.otpSent) {
          this.OTPVerificationMsg =
            "One Time Password(OTP) has been sent to your registered number, please verify it.";
          this.disableResendOtpButton();
        } else if(response.data.loginResponse) {
          /*
           * handle in Time session case
           */
          await this.$store.dispatch("setSession", response.data.loginResponse);
          if (response.data.clientInfo) {
            await this.$store.dispatch(
              "setClientInfo",
              response.data.clientInfo
            );
          }
          await setUserViewPermissions();
          this.$router.push(
            response &&
              response.data &&
              response.data.loginResponse &&
              response.data.loginResponse.user &&
              response.data.loginResponse.user.userType == 0
              ? "/superAdmin"
              : "/portal"
          );
        }
      } 
    }
  }
  /**
   * Verify Otp code
   */
  public async verifyOTP() {
    this.newPageLoader = true;
    let response = await Axios.post(API_STORE.AUTHENTICATION + "verifyOTP", {
      ...this.credentials,
      otp: this.inputOTP,
      customDomainCall: isSubdomain() ? true : false,
      subdomain: isSubdomain() ? getDomainName() : null,
      link: 'https://www.google.com/maps/@27.4792448,77.676544,14z'
    });
    this.newPageLoader = false;
    if (response && response.data && response.data.loginResponse) {
      /**
       * handle the success case of opt verification
       */
      await this.$store.dispatch("setSession", response.data.loginResponse);
      if (response.data.clientInfo) {
        await this.$store.dispatch("setClientInfo", response.data.clientInfo);
      }
      await setUserViewPermissions();
      localStorage.setItem(
        this.credentials.userName,
        JSON.stringify(new Date())
      );
      Swal.fire({
        position: "center",
        icon: "success",
        title: response.data.message,
        showConfirmButton: true,
      });
      this.$router.push(
        response.data.loginResponse.user.userType == 0
          ? "/superAdmin"
          : "/portal"
      );
    }
  }
  /**
   * Resend OTP
   */
  public async resendOTP() {
    this.newPageLoader = true;
    let response = await Axios.post(
      API_STORE.AUTHENTICATION + "resendMobileOTP",
      this.credentials
    );
    this.newPageLoader = false;
    if (response) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: response.data.message,
        showConfirmButton: true,
      });
      this.disableResendOtpButton();
    }
  }

  //get login sliders
  public async getLoggedInSliders() {
    try {
      this.newPageLoader = true;
      let response = await Axios.get(API_STORE.COMMON + "getLoggedInSliders");
      this.loginSlider1 =
        process.env.VUE_APP_AWS_S3_URL + response.data.slider1;
      this.loginSlider2 =
        process.env.VUE_APP_AWS_S3_URL + response.data.slider2;
      this.loginSlider3 =
        process.env.VUE_APP_AWS_S3_URL + response.data.slider3;
      this.newPageLoader = false;
    } catch (error) {
      console.log(error);
    }
  }

  //get lat or long
  public async initGeolocation() {
    if (navigator.geolocation) {
      // Call getCurrentPosition with success and failure callbacks
      navigator.geolocation.getCurrentPosition(this.success, this.fail);
    } else {
      alert("Sorry, your browser does not support geolocation services.");
    }
  }

  public async success(position) {
    this.latitude = position.coords.latitude;
    this.longitude = position.coords.longitude;
  }

  public async fail() {
    alert("Enable your location");
  }

  //Enable reset otp button after 60 sec
  disableResendOtpButton() {
    this.resendOtpDisabled = true;
    var scope = this;
    setTimeout(
      function () {
        scope.resendOtpDisabled = false;
      }.bind(this),
      30000
    );
  }

  mounted() {
    this.getLoggedInSliders();
    this.initGeolocation();
    if (!window.location.href.includes(this.$DOMAIN_ADDRESS) && this.$client) {
      this.showLogo = this.$clientLogo ? true : false;
      this.imageName = this.$companyName;
    }
    this.newPageLoader = false;
  }
}
